import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

function Loginapp() {
  const navigate = useNavigate();
  let { dealer } = useParams();
  let { token } = useParams();
  let server_url = localStorage.getItem("server_url");

  useEffect(() => {
    const timer = setTimeout(() => {
      // check_version();
      check_user();
    });
    return () => clearTimeout(timer); // cleanup
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function check_user() {
    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("dealer_id", dealer);
    formData.append("device_token", token);
    return axios
      .post(`${server_url}check_dealer.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((result) => {
        console.log(result.data);
        console.log(dealer);
        console.log(token);
        
        if (result.data.status === "1") {
          localStorage.setItem("token", token);
          localStorage.setItem(
            "notificaion_count",
            result.data.result[0].dealer_notification_count
          );
          localStorage.setItem(
            "LoginNumber",
            result.data.result[0].dealer_login_mobile
          );
          localStorage.setItem(
            "local_overdue_amount",
            result.data.result[0].overdue_amount
          );
          localStorage.setItem(
            "local_dealer_os",
            result.data.result[0].dealer_os
          );
          localStorage.setItem("order_date", result.data.result[0].order_date);
          localStorage.setItem(
            "local_items_in_cart",
            result.data.result[0].items_in_cart
          );
          localStorage.setItem(
            "local_current_order_status",
            result.data.result[0].current_order_status
          );
          localStorage.setItem(
            "local_order_final_total_with_gst",
            result.data.result[0].order_final_total_with_gst
          );
          localStorage.setItem(
            "local_order_id",
            result.data.result[0].order_id
          );
          localStorage.setItem(
            "admin_message",
            result.data.result[0].admin_message
          );
          localStorage.setItem(
            "local_dealer_firm_name",
            result.data.result[0].dealer_firm_name
          );
          localStorage.setItem("dealer_id", result.data.result[0].dealer_id);
          localStorage.setItem(
            "dealer_firm_name",
            result.data.result[0].dealer_firm_name
          );
          localStorage.setItem(
            "dealer_order_varification_mobile",
            result.data.result[0].dealer_order_varification_mobile
          );
          localStorage.setItem(
            "dealer_login_mobile",
            result.data.result[0].dealer_login_mobile
          );
          localStorage.setItem(
            "dealer_email",
            result.data.result[0].dealer_email
          );
          localStorage.setItem(
            "dealer_address",
            result.data.result[0].dealer_address
          );
          localStorage.setItem(
            "dealer_pincode",
            result.data.result[0].dealer_pincode
          );
          localStorage.setItem(
            "dealer_pan_number",
            result.data.result[0].dealer_pan_number
          );
          localStorage.setItem(
            "dealer_gst_number",
            result.data.result[0].dealer_gst_number
          );
          localStorage.setItem("city_name", result.data.result[0].city_name);
          localStorage.setItem("app_cache_clear", result.data.result[0].app_cache_clear);
          localStorage.setItem(
            "dealer_price_set",
            result.data.result[0].dealer_price_set
          );
          localStorage.setItem(
            "dealer_price_set_new",
            result.data.result[0].dealer_price_set_new
          );
          navigate("/");
        } else {
          navigate("/Logout");
        }
      });
  }
  return null; // No UI needed
}
export default Loginapp;
